<template>
    <div class="form-group">
        <div class="form-input" :class="{'is-active': isActive, 'is-focus': isFocus}">
            <input :type="type || 'text'" :value="value" class="form-control" :required="isRequired"
                   @focus="isFocus = true" @blur="isFocus = false" @input="$emit('input', $event.target.value)">
            <span class="form-input-placeholder">{{ placeholder }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormInput",
    props: ['value', 'placeholder', 'type', 'isRequired'],
    data(){
        return {
            isFocus: false,
        }
    },
    computed: {
        isActive(){
            return this.isFocus || this.value
        }
    }
}
</script>

<style lang="scss">
@import "../../../../sass/front/helpers";
.form {

    &-row {
        display: flex;
        gap: 20px;
        width: 100%;
    }

    &-block {
        margin-bottom: 30px;

        &-title {
            margin-bottom: 20px;
        }
    }
    &-group {
        flex: 1;
        margin-top: 3.6rem;

        @include responsive-below($lg) {
            margin-top: 2.4rem;
        }

        @include responsive-below($xs) {
            margin-top: 2rem;
        }
    }

    &-input {
        border: 1px solid #EEEEEE;
        border-radius: 0.8rem;
        position: relative;

        &-placeholder {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 1.5rem;
            color: $text-second;
            font-size: 1.4rem;
            font-weight: 300;
            pointer-events: none;
            transition: transform 0.3s;
        }

        &.is-active {
            .form-input-placeholder {
                font-size: 1.1rem;
                transform: translate(-1.5rem, -300%);
            }
        }

        &.is-focus {
            border-color: $text-main;
        }
    }

    &-control {
        border: 0;
        width: 100%;
        padding: 1.7rem 1.5rem;
        border-radius: 0.8rem;
        font-size: 1.5rem;
        font-family: 'Ukraine';

        &:focus {
            outline: none
        }
    }
}
</style>
